import _toArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toArray.js";
import _toConsumableArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function _asyncIterator(iterable) { var method, async, sync, retry = 2; for ("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;) { if (async && null != (method = iterable[async])) return method.call(iterable); if (sync && null != (method = iterable[sync])) return new AsyncFromSyncIterator(method.call(iterable)); async = "@@asyncIterator", sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s, this.n = s.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, "return": function _return(value) { var ret = this.s["return"]; return void 0 === ret ? Promise.resolve({ value: value, done: !0 }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, "throw": function _throw(value) { var thr = this.s["return"]; return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(s); }

function maybeImport(_x) {
  return _maybeImport.apply(this, arguments);
}

function _maybeImport() {
  _maybeImport = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(importFn) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", false ? importFn() : Promise.resolve(null));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _maybeImport.apply(this, arguments);
}

function getPkgJsonDir() {
  return _getPkgJsonDir.apply(this, arguments);
}

function _getPkgJsonDir() {
  _getPkgJsonDir = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var _yield$import, dirname, _yield$import2, constants, access, errors, _iterator3, _step3, path, prospectivePkgJsonDir;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return import("path");

          case 2:
            _yield$import = _context4.sent;
            dirname = _yield$import.dirname;
            _context4.next = 6;
            return import("fs");

          case 6:
            _yield$import2 = _context4.sent;
            constants = _yield$import2.constants;
            access = _yield$import2.promises.access;
            errors = [];
            _iterator3 = _createForOfIteratorHelper(module.paths);
            _context4.prev = 11;

            _iterator3.s();

          case 13:
            if ((_step3 = _iterator3.n()).done) {
              _context4.next = 27;
              break;
            }

            path = _step3.value;
            _context4.prev = 15;
            prospectivePkgJsonDir = dirname(path); // eslint-disable-next-line no-await-in-loop

            _context4.next = 19;
            return access(path, constants.F_OK);

          case 19:
            return _context4.abrupt("return", prospectivePkgJsonDir);

          case 22:
            _context4.prev = 22;
            _context4.t0 = _context4["catch"](15);
            errors.push(_context4.t0);

          case 25:
            _context4.next = 13;
            break;

          case 27:
            _context4.next = 32;
            break;

          case 29:
            _context4.prev = 29;
            _context4.t1 = _context4["catch"](11);

            _iterator3.e(_context4.t1);

          case 32:
            _context4.prev = 32;

            _iterator3.f();

            return _context4.finish(32);

          case 35:
            throw new Error("Cannot find project root dir. Underlying errors:\n\n ".concat(errors.join("\n")));

          case 36:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[11, 29, 32, 35], [15, 22]]);
  }));
  return _getPkgJsonDir.apply(this, arguments);
}

function getCacheFilename(_x2) {
  return _getCacheFilename.apply(this, arguments);
}

function _getCacheFilename() {
  _getCacheFilename = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(key) {
    var indexKey, hashData, _key, head, tail, hashPart, crypto, hashFn, hash;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (!(!key.length && key.length <= 0)) {
              _context5.next = 2;
              break;
            }

            throw new Error("Cache key is empty");

          case 2:
            hashData = null;

            if (Array.isArray(key)) {
              _key = _toArray(key), head = _key[0], tail = _key.slice(1);
              indexKey = head;
              hashData = tail;
            } else {
              indexKey = key;
            }

            hashPart = "";

            if (!(hashData && hashData.length > 0)) {
              _context5.next = 12;
              break;
            }

            _context5.next = 8;
            return maybeImport(function () {
              return import("crypto");
            });

          case 8:
            crypto = _context5.sent;
            hashFn = crypto === null || crypto === void 0 ? void 0 : crypto.createHash("sha1");
            hash = hashFn === null || hashFn === void 0 ? void 0 : hashFn.update(hashData.map(function (v) {
              return typeof v === "string" ? v : JSON.stringify(v);
            }).join("")).digest("hex");

            if (hash) {
              hashPart = "-".concat(hash);
            }

          case 12:
            return _context5.abrupt("return", "".concat(indexKey).concat(hashPart));

          case 13:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _getCacheFilename.apply(this, arguments);
}

function getDefaultCacheDirPath() {
  return _getDefaultCacheDirPath.apply(this, arguments);
}

function _getDefaultCacheDirPath() {
  _getDefaultCacheDirPath = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    var path;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return import("path");

          case 2:
            path = _context6.sent;
            _context6.t0 = path;
            _context6.next = 6;
            return getPkgJsonDir();

          case 6:
            _context6.t1 = _context6.sent;
            return _context6.abrupt("return", _context6.t0.resolve.call(_context6.t0, _context6.t1, "node_modules/.cache/fsCache"));

          case 8:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _getDefaultCacheDirPath.apply(this, arguments);
}

function invariantCacheFilePresent(_x3) {
  return _invariantCacheFilePresent.apply(this, arguments);
}

function _invariantCacheFilePresent() {
  _invariantCacheFilePresent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(cacheFilePath) {
    var _yield$import3, constants, fs;

    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return import("fs");

          case 2:
            _yield$import3 = _context7.sent;
            constants = _yield$import3.constants;
            fs = _yield$import3.promises;
            _context7.next = 7;
            return fs.access(cacheFilePath, constants.F_OK);

          case 7:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _invariantCacheFilePresent.apply(this, arguments);
}

function ensureCacheDirExists(_x4) {
  return _ensureCacheDirExists.apply(this, arguments);
}

function _ensureCacheDirExists() {
  _ensureCacheDirExists = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(cacheDirPath) {
    var _yield$import4, constants, fs;

    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return import("fs");

          case 2:
            _yield$import4 = _context8.sent;
            constants = _yield$import4.constants;
            fs = _yield$import4.promises;
            _context8.prev = 5;
            _context8.next = 8;
            return fs.access(cacheDirPath, constants.F_OK);

          case 8:
            _context8.next = 18;
            break;

          case 10:
            _context8.prev = 10;
            _context8.t0 = _context8["catch"](5);

            if (!(_context8.t0.code === "ENOENT")) {
              _context8.next = 17;
              break;
            }

            _context8.next = 15;
            return fs.mkdir(cacheDirPath, {
              recursive: true
            });

          case 15:
            _context8.next = 18;
            break;

          case 17:
            throw _context8.t0;

          case 18:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[5, 10]]);
  }));
  return _ensureCacheDirExists.apply(this, arguments);
}

function isCacheStale(metadata, staleTime) {
  return metadata.time - Date.now() + staleTime * 1000 < 0;
}

function loadCacheMetadata(_x5) {
  return _loadCacheMetadata.apply(this, arguments);
}

function _loadCacheMetadata() {
  _loadCacheMetadata = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(cacheFilePath) {
    var fs, readline, readable, readInterface, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, line;

    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return import("fs");

          case 2:
            fs = _context9.sent;
            _context9.next = 5;
            return import("readline");

          case 5:
            readline = _context9.sent;
            readable = fs.createReadStream(cacheFilePath);
            readInterface = readline.createInterface({
              input: readable,
              crlfDelay: Infinity
            }); // eslint-disable-next-line no-unreachable-loop

            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context9.prev = 10;
            _iterator = _asyncIterator(readInterface);

          case 12:
            _context9.next = 14;
            return _iterator.next();

          case 14:
            if (!(_iteratorAbruptCompletion = !(_step = _context9.sent).done)) {
              _context9.next = 20;
              break;
            }

            line = _step.value;
            return _context9.abrupt("return", JSON.parse(line));

          case 17:
            _iteratorAbruptCompletion = false;
            _context9.next = 12;
            break;

          case 20:
            _context9.next = 26;
            break;

          case 22:
            _context9.prev = 22;
            _context9.t0 = _context9["catch"](10);
            _didIteratorError = true;
            _iteratorError = _context9.t0;

          case 26:
            _context9.prev = 26;
            _context9.prev = 27;

            if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) {
              _context9.next = 31;
              break;
            }

            _context9.next = 31;
            return _iterator["return"]();

          case 31:
            _context9.prev = 31;

            if (!_didIteratorError) {
              _context9.next = 34;
              break;
            }

            throw _iteratorError;

          case 34:
            return _context9.finish(31);

          case 35:
            return _context9.finish(26);

          case 36:
            throw new Error("Cannot load cache metadata");

          case 37:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[10, 22, 26, 36], [27,, 31, 35]]);
  }));
  return _loadCacheMetadata.apply(this, arguments);
}

function loadCachedData(_x6) {
  return _loadCachedData.apply(this, arguments);
}

function _loadCachedData() {
  _loadCachedData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(cacheFilePath) {
    var fs, readline, readable, readInterface, data, isFirstLine, _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, line;

    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return import("fs");

          case 2:
            fs = _context10.sent;
            _context10.next = 5;
            return import("readline");

          case 5:
            readline = _context10.sent;
            readable = fs.createReadStream(cacheFilePath);
            readInterface = readline.createInterface({
              input: readable,
              crlfDelay: Infinity
            });
            data = "";
            isFirstLine = true;
            _iteratorAbruptCompletion2 = false;
            _didIteratorError2 = false;
            _context10.prev = 12;
            _iterator2 = _asyncIterator(readInterface);

          case 14:
            _context10.next = 16;
            return _iterator2.next();

          case 16:
            if (!(_iteratorAbruptCompletion2 = !(_step2 = _context10.sent).done)) {
              _context10.next = 25;
              break;
            }

            line = _step2.value;

            if (!isFirstLine) {
              _context10.next = 21;
              break;
            }

            isFirstLine = false;
            return _context10.abrupt("continue", 22);

          case 21:
            data += line;

          case 22:
            _iteratorAbruptCompletion2 = false;
            _context10.next = 14;
            break;

          case 25:
            _context10.next = 31;
            break;

          case 27:
            _context10.prev = 27;
            _context10.t0 = _context10["catch"](12);
            _didIteratorError2 = true;
            _iteratorError2 = _context10.t0;

          case 31:
            _context10.prev = 31;
            _context10.prev = 32;

            if (!(_iteratorAbruptCompletion2 && _iterator2["return"] != null)) {
              _context10.next = 36;
              break;
            }

            _context10.next = 36;
            return _iterator2["return"]();

          case 36:
            _context10.prev = 36;

            if (!_didIteratorError2) {
              _context10.next = 39;
              break;
            }

            throw _iteratorError2;

          case 39:
            return _context10.finish(36);

          case 40:
            return _context10.finish(31);

          case 41:
            return _context10.abrupt("return", JSON.parse(data));

          case 42:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[12, 27, 31, 41], [32,, 36, 40]]);
  }));
  return _loadCachedData.apply(this, arguments);
}

function isSubDir(_x7, _x8) {
  return _isSubDir.apply(this, arguments);
}
/**
 * Creates a file system cache function proxy. It stores function results in the
 * file system and reuses them as long as they are fresh. Useful to cache heavy
 * network requests while building static page via NextJS. Each function with
 * unique key is stored as a separate entry in a location set via options.
 *
 * @param key - globally unique caching key
 * @param fn - fetching function which returned data will be cached
 * @param opts - options object
 * @returns function proxy with caching layer
 */


function _isSubDir() {
  _isSubDir = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(parent, dir) {
    var path, relative;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.next = 2;
            return import("path");

          case 2:
            path = _context11.sent;
            relative = path.relative(parent, dir);
            return _context11.abrupt("return", relative && !relative.startsWith("..") && !path.isAbsolute(relative));

          case 5:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _isSubDir.apply(this, arguments);
}

export var createFsCacheProxy = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(key, fn, _ref) {
    var enabled, _ref$staleTime, staleTime, _ref$cacheDirPath, userCacheDirPath, fsClassic, path, fs, cacheDirPath, cacheFilename, cacheFilePath, targetCacheDirPath;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            enabled = _ref.enabled, _ref$staleTime = _ref.staleTime, staleTime = _ref$staleTime === void 0 ? 300 : _ref$staleTime, _ref$cacheDirPath = _ref.cacheDirPath, userCacheDirPath = _ref$cacheDirPath === void 0 ? process.env.FS_CACHE_PATH : _ref$cacheDirPath;
            _context2.next = 3;
            return maybeImport(function () {
              return import("fs");
            });

          case 3:
            fsClassic = _context2.sent;
            _context2.next = 6;
            return maybeImport(function () {
              return import("path");
            });

          case 6:
            path = _context2.sent;

            if (!(!fsClassic || !path || !enabled || true)) {
              _context2.next = 9;
              break;
            }

            return _context2.abrupt("return", fn);

          case 9:
            fs = fsClassic.promises;
            _context2.t0 = path;

            if (!(userCacheDirPath !== null && userCacheDirPath !== void 0)) {
              _context2.next = 15;
              break;
            }

            _context2.t1 = userCacheDirPath;
            _context2.next = 18;
            break;

          case 15:
            _context2.next = 17;
            return getDefaultCacheDirPath();

          case 17:
            _context2.t1 = _context2.sent;

          case 18:
            _context2.t2 = _context2.t1;
            cacheDirPath = _context2.t0.resolve.call(_context2.t0, _context2.t2);
            _context2.next = 22;
            return getCacheFilename(key);

          case 22:
            cacheFilename = _context2.sent;
            cacheFilePath = path.resolve(cacheDirPath, cacheFilename);
            targetCacheDirPath = path.dirname(cacheFilePath);
            _context2.t3 = cacheDirPath !== targetCacheDirPath;

            if (!_context2.t3) {
              _context2.next = 30;
              break;
            }

            _context2.next = 29;
            return isSubDir(cacheDirPath, targetCacheDirPath);

          case 29:
            _context2.t3 = !_context2.sent;

          case 30:
            if (!_context2.t3) {
              _context2.next = 32;
              break;
            }

            throw new Error("Cache file tries to jailbreak cache dir. Make sure that cache key doesn't start with eg. \"../\".");

          case 32:
            return _context2.abrupt("return", new Proxy(fn, {
              apply: function apply(target, _that, args) {
                return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                  var metadata, isCacheStaleValue, result, newCacheMetadata, stringifiedMetadata, dataToCache, cachePayload;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.prev = 0;
                          _context.next = 3;
                          return invariantCacheFilePresent(cacheFilePath);

                        case 3:
                          _context.next = 5;
                          return loadCacheMetadata(cacheFilePath);

                        case 5:
                          metadata = _context.sent;
                          _context.next = 8;
                          return isCacheStale(metadata, staleTime);

                        case 8:
                          isCacheStaleValue = _context.sent;

                          if (isCacheStaleValue) {
                            _context.next = 11;
                            break;
                          }

                          return _context.abrupt("return", loadCachedData(cacheFilePath));

                        case 11:
                          _context.next = 15;
                          break;

                        case 13:
                          _context.prev = 13;
                          _context.t0 = _context["catch"](0);

                        case 15:
                          _context.next = 17;
                          return target.apply(void 0, _toConsumableArray(args));

                        case 17:
                          result = _context.sent;
                          newCacheMetadata = {
                            time: Date.now()
                          };
                          stringifiedMetadata = JSON.stringify(newCacheMetadata);
                          _context.prev = 20;
                          dataToCache = JSON.stringify(result);
                          _context.next = 27;
                          break;

                        case 24:
                          _context.prev = 24;
                          _context.t1 = _context["catch"](20);
                          throw new Error("Failed to JSON stringify result. Caching only supported for simple data.\n\n Inner exception: \n".concat(dataToCache));

                        case 27:
                          cachePayload = stringifiedMetadata + "\n" + dataToCache;
                          _context.next = 30;
                          return ensureCacheDirExists(targetCacheDirPath);

                        case 30:
                          _context.next = 32;
                          return fs.writeFile(cacheFilePath, cachePayload, {
                            encoding: "utf8"
                          });

                        case 32:
                          return _context.abrupt("return", result);

                        case 33:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, null, [[0, 13], [20, 24]]);
                }))();
              }
            }));

          case 33:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function createFsCacheProxy(_x9, _x10, _x11) {
    return _ref2.apply(this, arguments);
  };
}();